var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h1',[_vm._v("Permissões")])])])
}]

export { render, staticRenderFns }